export const startDate = new Date('2020-04-09T13:00:00.000Z')
export const endRewardsDate = new Date('2020-12-11T13:00:00.000Z')
//new Date('2020-10-09T13:00:00.000Z')
